// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* global.css */
* {
    box-sizing: border-box;
}
html {
    font-size: 1.25em;
}
body {
    font-family: 'Work Sans', sans-serif;
}
h2 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
}
p {
    font-weight: 300;
    margin-bottom: 1.5rem;
    line-height: 1.5;
    hyphens: auto;
}
a {
    color: #939;
    text-decoration: none;
}
.wrap {
    max-width: 1250px;
    margin: 0 auto;
    padding: 0 1rem;
}
header {
    background: #57496e;
    color: #fff;
    padding: 1rem 0;
    margin-bottom: 2rem;
}
.header--flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header--logo a {
    font-size: 1.25rem;
    color: #fff;
}
header li {
    font-size: .8rem;
}
header nav a {
    color: #dbd;
}
header nav a:hover {
    color: #fff;
}

.header--signedin li {
    text-align: right;
    line-height: 1.25;
}
.header--signedout li {
    display: inline-block;
    margin-left: .5rem;
}
.course--module {
    background: #7c689b;
    border-radius: .5rem;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    display: block;
}
.course--label {
    color: #fff;
    font-size: .9rem;
    font-weight: 400;
    margin-bottom: .25rem;
}
.course--title {
    color: #fff;
    font-weight: 700;
    font-size: 1.25rem;
}
.course--add--module {
    background: #ddd9e4;
    color: #57496e;
    font-weight: 300;
    font-size: 1.25rem;
}
.course--add--title .add {
    width: 20px;
    height: auto;
    margin-right: 5px;
    fill: #57496e;
}
.course--detail--title {
    padding-bottom: .25rem;
    border-bottom: 1px solid #888;
    margin: 3rem 0 .5rem;
    font-size: .9rem;
    color: #555;
    text-transform: uppercase;
    letter-spacing: 2px;
}
.course--name {
    font-size: 2rem;
    margin-bottom: .5rem;
    font-weight: 700;
    color: #47395e;
}
.course--detail--list {
    font-weight: 300;
    margin: 0 0 1.5rem 1rem;
    line-height: 1.5;
}
.actions--bar {
    background: #e9e5f0;
    padding: 1rem 0;
    margin: -2rem 0 2rem;
}
.validation--errors {
    background: #e9e5f0;
    padding: 1rem;
    border-radius: .5rem;
    margin-bottom: 2.5rem;
}
.validation--errors h3 {
    color: #800;
    font-size: 1.25rem;
    margin-bottom: .5rem;
}
.validation--errors ul {
    font-weight: 300;
    margin-left: 1rem;
    line-height: 1.25;
}
.validation--errors li {
    margin-bottom: .5rem;
}
.validation--errors li:last-child {
    margin-bottom: 0;
}

.form--centered {
    max-width: 510px;
    margin: 0 auto;
    padding: 0 1rem;
}
form {
    margin-bottom: 2.5rem;
}
label {
    display: block;
    font-weight: 300;
    margin-bottom: .25rem;
}
input, textarea {
    display: block;
    width: 100%;
    color: #332a40;
    border-radius: .5rem;
    border: 1px solid #8c789b;
    padding: .5rem;
    margin-bottom: 1rem;
    font-family: 'Work Sans', sans-serif;
    font-size: .8rem;
}
textarea {
    min-height: 300px;
}
.button {
    background: #7c689b;
    color: #fff;
    font-size: 1rem;
    padding: .75rem 1.5rem;
    border: 0;
    margin: 0 0 .5rem 0;
    display: block;
    width: 210px;
    text-align: center;
    border-radius: .5rem;
    font-weight: bold;
    transition: background 0.2s;
}
.button:last-child {
    margin-bottom: 0;
}
.button:not(.button-secondary):hover {
    background: #63537d;
    cursor: pointer;
}
.button-secondary {
    color: #7c689b;
    background: none;
    box-shadow: 0 0 0 2px #7c689b inset;
    transition: box-shadow 0.2s, color 0.2s;
}
.button-secondary:hover {
    color: #63537d;
    box-shadow: 0 0 0 2px #63537d inset;
    cursor: pointer;
}

input:focus, button:focus, .button:focus, textarea:focus {
    border: none;
    border-radius: .5rem;
    outline: 2px solid #332a40;
    background: #e9e5f0;
}

@media screen and (min-width: 600px) {
    .header--signedin li {
        display: inline-block;
        margin-left: .5rem;
        line-height: 1;
    }
    .main--grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 1.5rem;
        grid-auto-rows: 1fr;
    }
}
@media screen and (min-width: 800px) {
    .main--grid {
        grid-template-columns: 1fr 1fr 1fr;
    }
    .main--flex {
        display: flex;
    }
    .main--flex div:first-child {
        flex-basis: 62%;
    }
    .main--flex div:last-child {
        margin-left: 8%;
        flex-basis: 30%;
    }
    .course--detail--title {
        margin: 1.5rem 0 .5rem;
    }
    .button {
        margin: 0 .5rem 0 0;
        display: inline-block;
    }
}`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,mCAAmC;IACnC,uCAAuC;AAC3C;AACA;IACI,cAAc;IACd,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI;QACI,qBAAqB;QACrB,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,kCAAkC;IACtC;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;QACnB,qBAAqB;IACzB;AACJ","sourcesContent":["/* global.css */\n* {\n    box-sizing: border-box;\n}\nhtml {\n    font-size: 1.25em;\n}\nbody {\n    font-family: 'Work Sans', sans-serif;\n}\nh2 {\n    font-size: 1.5rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n}\np {\n    font-weight: 300;\n    margin-bottom: 1.5rem;\n    line-height: 1.5;\n    hyphens: auto;\n}\na {\n    color: #939;\n    text-decoration: none;\n}\n.wrap {\n    max-width: 1250px;\n    margin: 0 auto;\n    padding: 0 1rem;\n}\nheader {\n    background: #57496e;\n    color: #fff;\n    padding: 1rem 0;\n    margin-bottom: 2rem;\n}\n.header--flex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.header--logo a {\n    font-size: 1.25rem;\n    color: #fff;\n}\nheader li {\n    font-size: .8rem;\n}\nheader nav a {\n    color: #dbd;\n}\nheader nav a:hover {\n    color: #fff;\n}\n\n.header--signedin li {\n    text-align: right;\n    line-height: 1.25;\n}\n.header--signedout li {\n    display: inline-block;\n    margin-left: .5rem;\n}\n.course--module {\n    background: #7c689b;\n    border-radius: .5rem;\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n    display: block;\n}\n.course--label {\n    color: #fff;\n    font-size: .9rem;\n    font-weight: 400;\n    margin-bottom: .25rem;\n}\n.course--title {\n    color: #fff;\n    font-weight: 700;\n    font-size: 1.25rem;\n}\n.course--add--module {\n    background: #ddd9e4;\n    color: #57496e;\n    font-weight: 300;\n    font-size: 1.25rem;\n}\n.course--add--title .add {\n    width: 20px;\n    height: auto;\n    margin-right: 5px;\n    fill: #57496e;\n}\n.course--detail--title {\n    padding-bottom: .25rem;\n    border-bottom: 1px solid #888;\n    margin: 3rem 0 .5rem;\n    font-size: .9rem;\n    color: #555;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n}\n.course--name {\n    font-size: 2rem;\n    margin-bottom: .5rem;\n    font-weight: 700;\n    color: #47395e;\n}\n.course--detail--list {\n    font-weight: 300;\n    margin: 0 0 1.5rem 1rem;\n    line-height: 1.5;\n}\n.actions--bar {\n    background: #e9e5f0;\n    padding: 1rem 0;\n    margin: -2rem 0 2rem;\n}\n.validation--errors {\n    background: #e9e5f0;\n    padding: 1rem;\n    border-radius: .5rem;\n    margin-bottom: 2.5rem;\n}\n.validation--errors h3 {\n    color: #800;\n    font-size: 1.25rem;\n    margin-bottom: .5rem;\n}\n.validation--errors ul {\n    font-weight: 300;\n    margin-left: 1rem;\n    line-height: 1.25;\n}\n.validation--errors li {\n    margin-bottom: .5rem;\n}\n.validation--errors li:last-child {\n    margin-bottom: 0;\n}\n\n.form--centered {\n    max-width: 510px;\n    margin: 0 auto;\n    padding: 0 1rem;\n}\nform {\n    margin-bottom: 2.5rem;\n}\nlabel {\n    display: block;\n    font-weight: 300;\n    margin-bottom: .25rem;\n}\ninput, textarea {\n    display: block;\n    width: 100%;\n    color: #332a40;\n    border-radius: .5rem;\n    border: 1px solid #8c789b;\n    padding: .5rem;\n    margin-bottom: 1rem;\n    font-family: 'Work Sans', sans-serif;\n    font-size: .8rem;\n}\ntextarea {\n    min-height: 300px;\n}\n.button {\n    background: #7c689b;\n    color: #fff;\n    font-size: 1rem;\n    padding: .75rem 1.5rem;\n    border: 0;\n    margin: 0 0 .5rem 0;\n    display: block;\n    width: 210px;\n    text-align: center;\n    border-radius: .5rem;\n    font-weight: bold;\n    transition: background 0.2s;\n}\n.button:last-child {\n    margin-bottom: 0;\n}\n.button:not(.button-secondary):hover {\n    background: #63537d;\n    cursor: pointer;\n}\n.button-secondary {\n    color: #7c689b;\n    background: none;\n    box-shadow: 0 0 0 2px #7c689b inset;\n    transition: box-shadow 0.2s, color 0.2s;\n}\n.button-secondary:hover {\n    color: #63537d;\n    box-shadow: 0 0 0 2px #63537d inset;\n    cursor: pointer;\n}\n\ninput:focus, button:focus, .button:focus, textarea:focus {\n    border: none;\n    border-radius: .5rem;\n    outline: 2px solid #332a40;\n    background: #e9e5f0;\n}\n\n@media screen and (min-width: 600px) {\n    .header--signedin li {\n        display: inline-block;\n        margin-left: .5rem;\n        line-height: 1;\n    }\n    .main--grid {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        column-gap: 1.5rem;\n        grid-auto-rows: 1fr;\n    }\n}\n@media screen and (min-width: 800px) {\n    .main--grid {\n        grid-template-columns: 1fr 1fr 1fr;\n    }\n    .main--flex {\n        display: flex;\n    }\n    .main--flex div:first-child {\n        flex-basis: 62%;\n    }\n    .main--flex div:last-child {\n        margin-left: 8%;\n        flex-basis: 30%;\n    }\n    .course--detail--title {\n        margin: 1.5rem 0 .5rem;\n    }\n    .button {\n        margin: 0 .5rem 0 0;\n        display: inline-block;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
